import React, { useCallback } from 'react'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Icon } from '@material-ui/core'

import Assets from 'app/configs/assetConfigs'
import { useAppLogo, useAppName } from 'commons/usePartner'
import {
  CHANNEL_APP,
  CHANNEL_SMS,
  CHANNEL_EMAIL,
  CHANNEL_CALL,
  TWITTER_VALUE,
  FACEBOOK_VALUE,
  INSTAGRAM_VALUE,
  LINKEDIN_VALUE,
  LINE_VALUE,
} from 'app/constants/channel'

import { SmsIcon, EmailIcon, AutomateCallIcon } from 'app/components/icons'
import { ReactComponent as TwitterChannel } from 'app/components/icons/twitter-channel-icon.svg'

import PrimaryTooltip from '../Tooltip/PrimaryTooltip'
import { channelName } from 'app/componentV4/Channel/ChannelsName'

const ChannelIcon = (props) => {
  const { channel, isTooltip = false, size = 20 } = props

  const appName = useAppName()
  const { logo: appLogo } = useAppLogo()

  const handleChannelIcon = useCallback(
    (channelInt) => {
      if (isNil(channelInt)) return

      switch (channelInt) {
        case CHANNEL_APP:
          return <img alt="app-icon" src={appLogo} width={size} height={size} />
        case CHANNEL_SMS:
          return (
            <Icon style={{ fontSize: 20 }}>
              <SmsIcon
                color={'#00B2AD'}
                classes={`w-${size}`}
                notBackground={false}
                backgroundColor={'#183560'}
              />
            </Icon>
          )
        case CHANNEL_EMAIL:
          return (
            <EmailIcon
              color={'#00B2AD'}
              classes={`w-${size}`}
              notBackground={false}
              backgroundColor={'#183560'}
            />
          )
        case CHANNEL_CALL:
          return (
            <AutomateCallIcon
              color={'#00B2AD'}
              classes={`w-${size}`}
              notBackground={false}
              backgroundColor={'#183560'}
            />
          )
        case TWITTER_VALUE:
          return <TwitterChannel />
        case FACEBOOK_VALUE:
          return (
            <img
              alt="channel-facebook-icon"
              src={Assets.facebookIcon}
              width={size}
              height={size}
            />
          )
        case INSTAGRAM_VALUE:
          return (
            <img
              alt="channel-instagram-icon"
              src={Assets.instagramIcon}
              width={size}
              height={size}
            />
          )
        case LINKEDIN_VALUE:
          return (
            <img
              alt="channel-linkin-icon"
              src={Assets.linkedinIcon}
              width={size}
              height={size}
            />
          )
        case LINE_VALUE:
          return (
            <img
              className="rounded-full"
              alt="channel-line-icon"
              src={Assets.lineIcon}
              width={size}
              height={size}
            />
          )
        default:
          return
      }
    },
    [appLogo],
  )

  return (
    <>
      {isTooltip ? (
        <PrimaryTooltip title={channelName(channel, appName)}>
          <div className="w-fit">{handleChannelIcon(channel)}</div>
        </PrimaryTooltip>
      ) : (
        handleChannelIcon(channel)
      )}
    </>
  )
}

ChannelIcon.propTypes = {
  isTooltip: PropTypes.bool,
  channel: PropTypes.number,
  size: PropTypes.number,
}

export default ChannelIcon
